import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OnboardingList } from '../../onboarding-creator/onboarding-creator.interfaces';
import { FinishedOnboardingList } from '../../onboarding/onboarding.interfaces';

@Injectable({
    providedIn: 'root'
})
export class OnSiteTrainingService {
    protected basePath = environment.apiPath;
    public defaultHeaders = new HttpHeaders();

    constructor(protected http: HttpClient) {
        this.defaultHeaders = this.defaultHeaders.append('Accept', 'application/json');
        this.defaultHeaders = this.defaultHeaders.append('Content-Type', 'application/json');
    }

    public onSiteTrainings(pageNumber: any, pageSize: any, sortBy: string, order: string, params: string, showSections?: number): Observable<any> {
        const headers = this.defaultHeaders;
        const url = `${this.basePath}/admin/on-site-training?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&${params}&showSections=${showSections}`;
        return this.http.get<any>(url, { headers });
    }

    public onSiteTrainingDates(id:number, pageNumber: any, pageSize: any, sortBy: string, order: string, params: string): Observable<any> {
        const headers = this.defaultHeaders;
        const url = `${this.basePath}/admin/on-site-training-dates/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&${params}`;
        return this.http.get<any>(url, { headers });
    }

    public onSiteTrainingDateUsers(id:number, pageNumber: any, pageSize: any, sortBy: string, order: string, params: string): Observable<any> {
        const headers = this.defaultHeaders;
        const url = `${this.basePath}/on-site-training-date-users/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&${params}`;
        return this.http.get<any>(url, { headers });
    }

    public onSiteTrainingDateUsersXls(id:number, params: string): string {
        return `/on-site-training-date-users/${id}/xls?${params}`;
    }

    public reorderOnSiteTrainings(ids: any): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/on-site-training/reorder`, { ids: [...ids] }, { headers });
    }

    public getAllOnSiteTrainingsToReorder(params: string): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.get<any>(`${this.basePath}/on-site-training/editor-list-by-weight${params}`, { headers });
    }

    public addOnSiteTraining(body: any, setCoverNull: boolean): Observable<any> {
        const headers = this.defaultHeaders;
        if (setCoverNull) {
            body.cover = null;
        }
        return this.http.post<any>(`${this.basePath}/on-site-training`, body, { headers });
    }

    public onSiteTrainingCheckName(body: any): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/on-site-training/check-name`, body, { headers });
    }

    public getOnSiteTraining(id: number | string, clone: boolean = false): Observable<any> {
        const headers = this.defaultHeaders;
        const params = clone ? '?clone=1' : '';
        return this.http.get<any>(`${this.basePath}/on-site-training/${id}${params}`, { headers });
    }

    public getOnSiteTrainingDates(id: number | string, clone: boolean = false): Observable<any> {
        const headers = this.defaultHeaders;
        const params = clone ? '?clone=1' : '';
        return this.http.get<any>(`${this.basePath}/on-site-training/${id}${params}`, { headers });
    }

    public addOnSiteTrainingDate(body: any, trainingId: number): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/on-site-training-date/${trainingId}`, body, { headers });
    }

    public deleteOnSiteTrainingDate(trainingId: number, id: number): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.delete<any>(`${this.basePath}/on-site-training-date/${trainingId}/${id}`, { headers });
    }

    public getOnSiteTrainingDate(onSiteTrainingId:number, id: number, clone: boolean = false, withTraining:boolean = false): Observable<any> {
        const headers = this.defaultHeaders;
        let params = '?withTraining=' + withTraining;
        if (clone) {
            params += '&clone=1'
        }
        return this.http.get<any>(`${this.basePath}/on-site-training-date/${onSiteTrainingId}/${id}${params}`, { headers });
    }

    public downloadOnSiteTraining(params: string): string {
        return `/admin/on-site-training/xls?${params}`;
    }

    public downloadOnSiteTrainingDates(id:number, params: string): string {
        return `/admin/on-site-training-dates/${id}/xls?${params}`;
    }

    public saveAvailabilityOnSiteTrainingUsers(pathId: number, availability: any): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/admin/on-site-training/${pathId}/availability`, { availability }, { headers });
    }

    public assign(id: number, body: any): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/admin/on-site-training-date/${id}/assign`, body, { headers });
    }

    public assignedList(id: number): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.get<any>(`${this.basePath}/admin/on-site-training/${id}/assigned`, { headers });
    }

    public assignedCount(id: number): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.get<any>(`${this.basePath}/admin/on-site-training/${id}/assigned/count`, { headers });
    }

    public userChecklist(id: number): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.get<any>(`${this.basePath}/admin/on-site-training-date/${id}/user-checklist`, { headers });
    }

    public resetAttendance(id: number, usersIds: any[]): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/on-site-training-date/${id}/reset-attendance`, {usersIds}, { headers });
    }

    public setAttendance(id: number, users: any[]): Observable<any> {
        const headers = this.defaultHeaders;
        return this.http.post<any>(`${this.basePath}/on-site-training-date/${id}/set-attendance`, {users}, { headers });
    }

    getTrainingsOrganization(companyId: number, pageNumber: number, pageSize: number, sortBy: string, order: string, params: string): Observable<OnboardingList> {
        const headers = this.defaultHeaders;
        return this.http.get<OnboardingList>(`${this.basePath}/company/${companyId}/organization/on-site-trainings?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&${params}`, { headers });
    }

    getTrainingsOrganizationXLS(companyId: number, params: string): string {
        return `/company/${companyId}/organization/on-site-trainings/xls?${params}`;
    }

    onSiteTrainingOrganizationReportXLS(companyId: number, trainingId: number, params: string): string {
        return `/company/${companyId}/organization/on-site-trainings/${trainingId}/report/xls?${params}`;
    }


    getTrainingsTeam(userId: number, pageNumber: number, pageSize: number, sortBy: string, order: string, params: string): Observable<OnboardingList> {
        const headers = this.defaultHeaders;
        return this.http.get<OnboardingList>(`${this.basePath}/user/${userId}/team/on-site-trainings?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&${params}`, { headers });
    }

    getTrainingsTeamXLS(userId: number, params: string): string {
        return `/user/${userId}/team/on-site-trainings/xls?${params}`;
    }

    onSiteTrainingTeamReportXLS(userId: number, trainingId: number, params: string): string {
        return `/user/${userId}/team/on-site-trainings/${trainingId}/report/xls?${params}`;
    }
}
